module.exports = __webpack_public_path__ + "static/media/icon.f61ec4b7.png";